import { Table } from '@dixa/lib-shared-habla';

import { ActionsMenu, ActionsMenuProps } from './actionsMenu';
import style from './style.module.scss';

type Props = ActionsMenuProps & {
  readonly messengerName: string;
};

export function MessengerRow({ messengerName, ...rest }: Props): JSX.Element {
  return (
    <Table.Tr>
      <Table.Td
        className={style.messengerNameCell}
        onClick={rest.onEditSettings}
      >
        {messengerName}
      </Table.Td>
      <Table.Td align="right">
        <ActionsMenu {...rest} />
      </Table.Td>
    </Table.Tr>
  );
}
